module.exports = __webpack_public_path__ + "site/img/tc.6939a307.png";